import { useTranslate } from '@tolgee/react';
import { GetStaticProps } from 'next';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Container from '@amf/shared/components/layout/Container';
import ContactSend from '@amf/shared/components/contact/ContactSend';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

interface ContactPageProps extends NavigationProps {}

export default function ContactPage({ navigation, partners }: ContactPageProps) {
  const { t } = useTranslate();
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <div className='ContactPage'>
        <Layout navigation={navigation} partners={partners}>
          <Meta title={t('contact.title')} />
          <Container>
            <h1>{t('contact.title')}</h1>
            <div className='ContactPage__content'>
              <ContactSend buttonProps={{ variant: 'dark' }} />
              <div className='ContactPage__info'>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.info.title')}</h2>
                  <address>Rostislav Vítek</address>
                  <p>
                    <a href='mailto:rostislav.vitek@shopsys.com'>rostislav.vitek@shopsys.com</a>
                    <br />
                    <a href='tel:+420792754229'>+420 792 754 229</a>
                  </p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.billing.title')}</h2>
                  <address>
                    <strong>Malý Fotbal Ostrava, z.s.</strong>
                    <br />
                    Čujkovova 48A
                    <br />
                    700 30 Ostrava
                  </address>
                  <p>IČ: 07909535</p>
                  <p>
                    {t('contact.billing.account')}:{' '}
                    <a
                      href='https://ib.fio.cz/ib/transparent?a=2801655794&fbclid=IwAR32EiFTqj7vrIkl_ZY0fQW-zd7JWXwucqG0k7yGcWN96fswBCFsYOogL9Y'
                      target='_blank'
                      rel='noreferrer'
                    >
                      2801655794/2010
                    </a>
                  </p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.social.title')}</h2>
                  <p>
                    <a
                      href='https://www.facebook.com/malyfotbalostrava'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Facebook
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <h2 className='h1'>{t('contact.persons.title')}</h2>
            <div className='ContactPage__personList'>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>Rostislav Vítek</h3>
                  <p>
                    Vedení soutěže
                    <br />
                    <br />
                    <a href='tel:+420792754229'>+420 792 754 229</a>
                    <br />
                    <a href='mailto:rostislav.vitek@shopsys.com'>rostislav.vitek@shopsys.com</a>
                    <br />
                  </p>
                </div>
              </div>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>Jiří Chalota</h3>
                  <p>Vedení soutěže</p>
                </div>
              </div>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>René Bulař</h3>
                  <p>Vedení soutěže</p>
                </div>
              </div>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>Marcel Bednář</h3>
                  <p>Vedení soutěže</p>
                </div>
              </div>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>Jan Mikšovič</h3>
                  <p>Vedení soutěže</p>
                </div>
              </div>
            </div>
          </Container>
        </Layout>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
